import React, { useState, useEffect } from 'react';
import { Select, Button, message, Form } from 'antd';
import { useAuthOrg } from '../../context/AuthOrgContext';
import coreAPIService from '../../apiServices/coreAPIService';
import { CTW_API_ENDPOINT } from '../../utils';
import Heading from '../../common/Heading';
import { useBreadcrumbs } from '../../context/BreadcrumbContext';
import { useNavigate } from 'react-router-dom';

const LeadConfiguration: React.FC = () => {
    const { availableOrgs, currentOrg } = useAuthOrg();
    const [loading, setLoading] = useState(false);
    const [selectedOrgId, setSelectedOrgId] = useState(currentOrg?.orgId || '');
    const [leadDefinition, setLeadDefinition] = useState<'LeadSubmitted' | 'QualifiedLead'>('LeadSubmitted');
    const { setBreadcrumbs } = useBreadcrumbs();
    const navigate = useNavigate();


    useEffect(() => {
        setBreadcrumbs([
            { title: <div className="text-lg cursor-pointer" onClick={() => navigate("/settings")}>Settings</div> },
            { title: <div className="text-lg">Lead Configuration</div> },
        ]);
    }, [setBreadcrumbs, navigate]);

    useEffect(() => {
        if (selectedOrgId) {
            fetchConfiguration(selectedOrgId);
        }
    }, [selectedOrgId]);

    const fetchConfiguration = async (orgId: string) => {
        setLoading(true);
        try {
            const res = await coreAPIService.get<any>(
                CTW_API_ENDPOINT,
                `v2/util/default-lead-config?org_id=${orgId}`,
            );
            if (res.meta.code === 200 && res.data) {
                setLeadDefinition(res.data.leadDefinition || 'LeadSubmitted');
            }
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async () => {
        setLoading(true);
        try {
            const res = await coreAPIService.put<any>(
                CTW_API_ENDPOINT,
                `v2/util/default-lead-config`,
                { orgId: selectedOrgId, milestoneName: leadDefinition }
            );
            if (res.meta.code === 200) {
                message.success("Configuration saved successfully");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="px-10 py-8 flex flex-col gap-8">
            <div className="bg-white shadow-md rounded-xl p-8">

                <Heading title="Lead Configuration" />

                <div className="mt-6 max-w-xl space-y-6">
                    <Form layout="vertical">
                        <Form.Item label="Select Account">
                            <Select
                                value={selectedOrgId}
                                onChange={setSelectedOrgId}
                                className="w-full"
                            >
                                {availableOrgs.map(org => (
                                    <Select.Option
                                        key={org.orgId}
                                        value={org.orgId}
                                    >
                                        {org.orgName}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item label="Lead Definition">
                            <p className="text-sm text-gray-500 mb-2">
                                Define what constitutes a lead for your account.
                            </p>
                            <Select
                                value={leadDefinition}
                                onChange={setLeadDefinition}
                                className="w-full"
                            >
                                <Select.Option value="LeadSubmitted">
                                    LeadSubmitted
                                </Select.Option>
                                <Select.Option value="QualifiedLead">
                                    QualifiedLead
                                </Select.Option>
                            </Select>
                        </Form.Item>

                        <Form.Item className="pt-4">
                            <Button
                                type="primary"
                                onClick={handleSave}
                                loading={loading}
                                className="bg-[#1F344C]"
                            >
                                Save Configuration
                            </Button>
                        </Form.Item>
                    </Form>
                </div>

            </div>
        </section>
    );
};


export default LeadConfiguration;
